import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { ProductService } from '../../../service/product.service';
import { Product } from '../../../models/Product';
import { ModalEditProduct } from '../modal-edit-product/modal-edit-product';
import { Router } from '@angular/router';
import { exportRowsToExcel } from '../../../shared/utils/excel-export.util';

@Component({
  selector: 'app-search-product',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, ModalEditProduct],
  templateUrl: './search-product.html',
  styleUrl: './search-product.scss'
})
export class SearchProduct {

  private fb = inject(FormBuilder);
  private productService = inject(ProductService);
  private router = inject(Router);

  searchForm = this.fb.group({
    term: ['']
  });

  loading = signal(false);
  products = signal<Product[]>([]);
  error = signal<string | null>(null);
  hasSearched = signal(false);

  selectedProduct: Product | null = null;

  onSearch() {
    const term = this.searchForm.value.term?.trim().toLowerCase() || '';
    if (!term) {
      this.error.set('Ingrese un término de búsqueda.');
      return;
    }

    this.loading.set(true);
    this.error.set(null);
    this.hasSearched.set(true);

    this.productService.getAll().subscribe({
      next: data => {
        this.loading.set(false);
        this.products.set(
          data.filter(p =>
            p.nombre?.toLowerCase().includes(term) ||
            p.codigoIne?.toLowerCase().includes(term)
          )
        );
      },
      error: () => {
        this.loading.set(false);
        this.error.set('Error al buscar productos.');
      }
    });
  }

  onListAll() {
    this.loading.set(true);
    this.error.set(null);
    this.hasSearched.set(true);

    this.productService.getAll().subscribe({
      next: data => {
        this.loading.set(false);
        this.products.set(data);
      },
      error: () => {
        this.loading.set(false);
        this.error.set('Error al consultar todos los productos.');
      }
    });
  }

  openEdit(p: Product) {
    this.selectedProduct = p;

    const modal = new (window as any).bootstrap.Modal(
      document.getElementById('modalEditProduct')
    );
    modal.show();
  }

  onProductDeleted(codigo: number) {
    this.products.update(list => list.filter(p => p.codigo !== codigo));
    this.selectedProduct = null;
  }

  onProductUpdated(updated: Product) {
    this.products.update(list =>
      list.map(p => (p.codigo === updated.codigo ? updated : p))
    );
  }

  viewVarieties(codigo: number) {
    this.router.navigate(['/product', codigo, 'varieties']);
  }

  exportExcel(): void {
    exportRowsToExcel(this.products().map(p => ({
      'Código': p.codigo,
      'Código de sección': p.fkSeccion,
      'Código de división': p.fkDivision,
      'Código de clase': p.fkClase,
      'Código INE': p.codigoIne,
      'Nombre': p.nombre,
      'Ponderación': p.ponderacion,
      'Ponderación importado': p.ponderacionImportado,
      'Ponderación general': p.ponderacionGeneral,
      'Canasta': p.canasta,
      'Código CIIU': p.codigoCiiu,
      'Código NAEG': p.codigoNaeg,
      'Código NPG': p.codigoNpg,
      'Código CCP': p.codigoCcp,
      'Referencia': p.referencia,
      'Estado': p.estado === 'A' ? 'Activo' : 'Inactivo',
      'Función de auditoría': p.segFuncion,
      'Usuario de auditoría': p.segUsuario,
      'Transacción de auditoría': p.segTransaccion,
      'Datos anteriores': p.segDatosAnteriores
    })), 'mantenimiento-productos', 'Productos');
  }
}
